import {
  NavigationLinkWrapper,
  NavigationIconWrapper,
  DropdownIcon,
  CategoryText,
} from '../../blog-navigation.styles';
import SVG from '@glowforge/gf-styled/src/components/svg/svg';
import { Image as BuilderImage } from '@builder.io/react';
const NavigationLink = ({ item, isSubNav }) => {
  return (
    <NavigationLinkWrapper className='navigation-link-wrapper'>
      {item?.image && (
        <NavigationIconWrapper>
          <BuilderImage
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'contain',
            }}
            lazy='false'
            image={item?.image}
          />
        </NavigationIconWrapper>
      )}
      {item?.navText && <CategoryText>{item?.navText}</CategoryText>}
      {isSubNav && (
        <DropdownIcon className='icon'>
          <SVG
            id='chevron-down'
            fill='#000'
            stroke='#000'
            width={10}
            height={10}
          />
        </DropdownIcon>
      )}
    </NavigationLinkWrapper>
  );
};

export default NavigationLink;
